/**
 * Magic-link guest session storage.
 * A guest is an invited colleague who joined via a magic link — they have no
 * external wallet; their session is a JWT issued by the orchestrator that
 * scopes them to the inviter's chat room.
 */
const STORAGE_KEY = "dw_guest_session";
let memorySession = null;
let memorySessionIsAuthoritative = false;
export function getOrchestratorBaseUrl() {
    const base = process.env.CHAT_WS_URL || process.env.ORCHESTRATOR_URL || "/orchestrator";
    return base.replace(/\/$/, "");
}
export function saveGuestSession(session) {
    // Keep the active SPA navigation working even when iOS privacy settings,
    // an in-app browser, or storage quota blocks localStorage writes.
    memorySession = session;
    memorySessionIsAuthoritative = true;
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    }
    catch {
        // The in-memory session remains available until the tab is closed.
    }
}
export function loadGuestSession() {
    if (memorySessionIsAuthoritative)
        return memorySession;
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return memorySession;
        const parsed = JSON.parse(raw);
        if (!parsed.sessionJwt || !parsed.room)
            return memorySession;
        memorySession = parsed;
        memorySessionIsAuthoritative = true;
        return parsed;
    }
    catch {
        return memorySession;
    }
}
export function clearGuestSession() {
    memorySession = null;
    memorySessionIsAuthoritative = true;
    try {
        localStorage.removeItem(STORAGE_KEY);
    }
    catch {
        // Storage may be unavailable; clearing the in-memory copy is sufficient.
    }
}
/** Local expiry check (server re-checks on every request/WS connect). */
export function isGuestSessionLikelyValid(session) {
    if (!session)
        return false;
    try {
        const payload = JSON.parse(atob(session.sessionJwt.split(".")[1]));
        if (payload.exp && payload.exp * 1000 < Date.now())
            return false;
        return true;
    }
    catch {
        return false;
    }
}
